import { render, staticRenderFns } from "./_side-bar.vue?vue&type=template&id=da09507a&"
import script from "./_side-bar.vue?vue&type=script&lang=js&"
export * from "./_side-bar.vue?vue&type=script&lang=js&"
import style0 from "./_side-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports